import { render, staticRenderFns } from "./DSKH-Team-V2.vue?vue&type=template&id=0c8cb062"
import script from "./DSKH-Team-V2.vue?vue&type=script&lang=js"
export * from "./DSKH-Team-V2.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports